import React from "react";
import {Language} from "types/models";
import {UkSVG, VnSVG} from "assets";
/* eslint-disable no-var */

const languages: Language[] = [
  {
    key: "vn",
    name: "Tiếng Việt",
    icon: <VnSVG width={18} style={{marginRight: "4px"}}></VnSVG>,
  },
  {
    key: "en",
    name: "English",
    icon: <UkSVG width={18} style={{marginRight: "4px"}}></UkSVG>,
  },
];
export {languages};
